import { Button } from '@/ui-components/atoms/Button/Button';

export function formatSatelliteChannel(channel: string | number | undefined): string {
    return channel ? `CH ${channel}` : '-';
}

export function renderChannelLink(
    deepLink: string | undefined,
    channelNumber: string | number | undefined,
    ariaLabel: string,
): React.ReactNode {
    if (deepLink) {
        return (
            <Button
                type="button"
                variant="secondary"
                fitting="hug-contents"
                href={deepLink}
                size="x-small"
                ariaLabel={ariaLabel}
                linkTarget="_blank"
            >
                CH {channelNumber}
            </Button>
        );
    }
    return formatSatelliteChannel(channelNumber);
}
